const PDF = ({ path }) => {
  window.location.replace(path);
  return null;
};

export default PDF;
